import { useEffect } from 'react';
import { FormBehavior, observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import { showAlert, useStores } from '~/utils';
import OnboardingAddress from './OnboardingAddress';
import { type OnboardingAddressFormValues, validationSchema } from './schema';

const OnboardingAddressContainer = () => {
  const navigate = useNavigate();
  const { user } = useStores();
  const onSubmit = async (values: OnboardingAddressFormValues) => {
    user.updateAddressData(values);
    await user.updateCreditOnboardingUserAccount();
    navigate(Routes.ONBOARDING_SELFIE);
  };

  useEffect(() => {
    if (!user.addressData.foundAddress) {
      showAlert({
        message: 'Não conseguimos encontrar seu CEP',
      });
    }
  }, [user.addressData.foundAddress]);

  return (
    <FormBehavior
      validationSchema={validationSchema}
      initialValues={user.addressData}
      onSubmit={onSubmit}
    >
      <OnboardingAddress />
    </FormBehavior>
  );
};

export default observer(OnboardingAddressContainer);
